import { render, staticRenderFns } from "./FarmTagsChips.vue?vue&type=template&id=4d116bf2&scoped=true&"
import script from "./FarmTagsChips.vue?vue&type=script&lang=ts&"
export * from "./FarmTagsChips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d116bf2",
  null
  
)

export default component.exports